import { FormikHelpers, useFormik } from 'formik';
import { TeamCreate } from '../team';
import {
  Grid,
  TextField,
  Box,
  FormHelperText,
  Paper,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

type TeamProps = {
  onSubmit: (
    value: TeamCreate,
    helpers: FormikHelpers<TeamCreate>
  ) => Promise<boolean>;
  submitting: boolean;
};

const CreateTeamForm = ({ onSubmit, submitting }: TeamProps) => {
  const navigate = useNavigate();

  const handleSubmit = async (
    value: TeamCreate,
    helpers: FormikHelpers<TeamCreate>
  ) => {
    const success = await onSubmit(value, helpers);
    if (success) {
      formik.resetForm();
      navigate('/', { replace: true });
      navigate('/teams/create', { replace: true });
    }
  };

  const initialValues: TeamCreate = {
    name: '',
    position: '',
    description: '',
    photo: null,
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });

  // console.log('Edit Form', initialValues);

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={9}>
              <Paper sx={{ p: 2, pb: 3 }}>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="name"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Name"
                      placeholder="Name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.name)}
                      helperText={formik.errors.name}
                    />
                  </Grid>

                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="position"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Position"
                      placeholder="Position"
                      value={formik.values.position}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.position)}
                      helperText={formik.errors.position}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="description"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Description"
                      placeholder="Description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.description)}
                      helperText={formik.errors.description}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <Grid item xs={12}>
                      Photo
                    </Grid>
                    <Box>
                      <input
                        type="file"
                        onChange={({ target: { files } }) => {
                          formik.setFieldValue(
                            'photo',
                            files && files.length ? files[0] : null
                          );
                        }}
                        name="photo"
                      />
                    </Box>
                    {formik.touched.photo && formik.errors.photo && (
                      <FormHelperText error>
                        {formik.errors.photo}
                      </FormHelperText>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Paper sx={{ p: 2 }}>
                <Grid container>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    size="small"
                  >
                    {submitting ? 'Saving' : 'Save'}
                  </Button>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default CreateTeamForm;
